// As últimas lojas escolhidas por dashboard e ambiente, guardadas só neste navegador: a primeira abre com um toque na visita seguinte.

const MAXIMO = 5

export const chaveRecentes = (dashboardId: number, ambienteId: number) => `np-lojas-recentes:${dashboardId}:${ambienteId}`

export function lojasRecentes(chave: string): string[] {
  try {
    const v = JSON.parse(window.localStorage.getItem(chave) || '[]')
    return Array.isArray(v) ? v.filter(x => typeof x === 'string').slice(0, MAXIMO) : []
  } catch {
    return []
  }
}

export function lembrarLoja(chave: string, id: string) {
  try {
    const nova = [id, ...lojasRecentes(chave).filter(x => x !== id)].slice(0, MAXIMO)
    window.localStorage.setItem(chave, JSON.stringify(nova))
  } catch { /* armazenamento cheio ou bloqueado: só não lembra */ }
}
